import { Box, BoxProps, ColorOptions, Image as NewImage, Spacer, Text as NewText } from '@jfs/ui-new'
import React, { FC } from 'react'
import { ViewStyle } from 'react-native'
import Comprehensive from '../../assets/svg/Comprehensive'
import Robust from '../../assets/svg/Robust'
import Versatile from '../../assets/svg/Versatile'
import { footerStrings, staticStrings } from '../../static/staticStrings'
import { colors } from '../../util/colors'
import useFontSize from '../../util/useFontSize'
import usePadding from '../../util/usePadding'
import { isMobileWidth, isTabletWidth, useWindowDimensions } from '../../util/util'

const compliant = require('../../assets/svg/compliant.svg')

const whyJioData = [
  {
    id: 'versatile',
    component: Versatile,
    header: 'Versatile',
    subtext: staticStrings.vesatilePara,
  },
  {
    id: 'comprehensive',
    component: Comprehensive,
    header: 'Comprehensive',
    subtext: staticStrings.compPara,
  },
  {
    id: 'compliant',
    uri: compliant,
    header: 'Compliant',
    subtext: staticStrings.compliantPara,
  },
  {
    id: 'robust',
    component: Robust,
    header: 'Robust',
    subtext: staticStrings.robustPara,
  },
]

const WhyJioBox = (item: any, themedStyle: any, isMob: boolean, _isTab: boolean): React.ReactElement => {
  const Component = item?.component
  return (
    <Box
      ph={isMob ? 0 : _isTab ? 24 : 16}
      pv={isMob ? 28 : _isTab ? 32 : 20}
      key={item.id}
      underlayColor="TRANSPARENT"
      f={isMob || _isTab ? undefined : 1}>
      <>
        <Box key={item.header} {...themedStyle.textContentOverlap}>
          {!!item.uri && (
            <NewImage
              source={item.uri}
              height={isMob || _isTab ? 48 : 56}
              width={isMob || _isTab ? 48 : 56}
              borderRadius={23}
            />
          )}
          {!!item.component && <Component height={isMob || _isTab ? 48 : 56} width={isMob || _isTab ? 48 : 56} />}
          <Box {...themedStyle.whyjiodime}>
            <NewText
              fontFamily="jiotype-bold"
              color="WHITE"
              fontSize={isMob || _isTab ? 18 : 24}
              lineHeight={isMob || _isTab ? 24 : 30}>
              {item.header}
            </NewText>
          </Box>
          <NewText
            color="WHITE"
            opacity={0.7}
            fontFamily="jiotype-medium"
            lineHeight={isMob || _isTab ? 18 : 26}
            fontSize={isMob || _isTab ? 14 : 18}>
            {item.subtext}
          </NewText>
        </Box>
      </>
    </Box>
  )
}

export const WhyJioHomeSection: FC = () => {
  const { headerSize, textSize } = useFontSize()

  const viewPortWidth = useWindowDimensions()
  const isTab = isTabletWidth(viewPortWidth)
  const isMob = isMobileWidth(viewPortWidth)
  const responsivePadding = usePadding()
  const themedStyle = styles(viewPortWidth, responsivePadding)

  const WhyJioContent = whyJioData.map((item) => {
    return WhyJioBox(item, themedStyle, isMob, isTab)
  })

  return (
    <Box
      nativeID="whyjio"
      mt={isTab ? 100 : isMob ? 0 : 60}
      ph={responsivePadding}
      pt={isMob ? 80 : 160}
      pb={isMob ? 80 : 280}
      borderTopLeftRadius={isMob ? 32 : 120}
      borderTopRightRadius={isMob ? 32 : 120}
      bg={colors.JIO_PRIMARY_ALPHA as ColorOptions}>
      <NewText color="WHITE" fontFamily="jiotype-black" fontSize={headerSize}>
        {footerStrings.whyjio}
      </NewText>
      <Spacer size={isMob ? 16 : 32} />
      <Box w={isMob ? undefined : '60%'}>
        <NewText color="WHITE" fontFamily="jiotype-medium" fontSize={textSize} lineHeight={isMob ? 20 : 32}>
          {staticStrings.whyJioPara}
        </NewText>
      </Box>
      <Box {...themedStyle.content} {...themedStyle.whyjiofix}>
        <Box {...themedStyle.whyjiocontainer}>{WhyJioContent}</Box>
      </Box>
    </Box>
  )
}

export const styles = (breakpoint: number, responsivePadding: number) => {
  const isMobile = isMobileWidth(breakpoint)
  const isTab = isTabletWidth(breakpoint)
  const isDesktop = breakpoint > 1024
  // const responsivePadding = getPadding(breakpoint)
  return {
    content: {
      display: 'flex',
      flexDirection: isMobile ? 'column' : 'row',
      flexWrap: 'wrap',
      // paddingHorizontal: responsivePadding,
      mt: isTab ? 10 : isMobile ? 24 : 40,
    } as BoxProps,
    whyJioTextContainer: (isTopLeft: boolean, isTopRight: boolean) =>
      ({
        minWidth: isTab ? 336 : isMobile ? undefined : 260,
        minHeight: isTab ? (isTopLeft || isTopRight ? 268 : 288) : isMobile ? undefined : 380,
        width: isMobile ? breakpoint - 48 : breakpoint / 4 - (responsivePadding / 4) * 2,
        marginBottom: isTab || isMobile ? 0 : 20,
        padding: isDesktop ? 24 : isMobile ? 0 : 18,
        borderRadius: 8,
        zIndex: 10,
      } as ViewStyle),
    textContentOverlap: {
      minHeight: isMobile || isTab ? undefined : 265,
      maxWidth: isTab ? 336 : isMobile ? undefined : 232,
    } as BoxProps,
    ImageKeyborad: {
      width: 24,
      height: 24,
      marginTop: 5,
    } as ViewStyle,
    dimRightArrow: {
      width: 20,
      height: 20,
      opacity: 0.2,
      marginTop: 3,
    } as ViewStyle,
    whyjioArrow: {
      opacity: 0.2,
      marginTop: 8,
      marginLeft: 8,
    } as ViewStyle,
    whyjiodime: {
      marginBottom: isMobile || isTab ? 4 : 16,
      marginTop: isMobile ? 16 : 32,
    } as ViewStyle,
    whyjiofix: {
      minHeight: isMobile ? '50vh' : undefined,
      height: isTab ? undefined : '100%',
      w: '100%',
    } as BoxProps,
    whyjiocontainer: {
      display: 'flex',
      width: '100%',
      zIndex: 10,
      flexDirection: isMobile ? 'column' : 'row',
      // justifyContent: 'center',
      alignItems: 'flex-start',
      flexWrap: 'wrap',
    } as BoxProps,
    merchantPartner: {
      position: 'absolute',
      left: isMobile || isTab ? 60 : 130,
      // top: 100,
      alignSelf: 'center',
    } as BoxProps,
    dotImageContainer: {
      position: 'absolute',
      left: isMobile ? 30 : isTab ? 80 : responsivePadding + 5,
      zIndex: -99,
      top: isMobile ? -10 : isTab ? -25 : -30,
    } as BoxProps,
    borderLine: {
      width: breakpoint - 48,
      backgroundColor: 'BORDER_COLOR',
      height: -5,
      alignSelf: 'center',
    } as BoxProps,
  }
}
